export default __webpack_public_path__ + "static/media/service2.7d68e46a.png";